import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcOffsetToTime',
})
export class UtcOffsetToTimePipe implements PipeTransform {
  private static readonly mskOffset = 3;

  transform(offset: number): any {
    if (offset == null) {
      return null;
    }

    const date = new Date();
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;
    const theDate = new Date(utc + 3600000 * offset);

    const time = theDate.toLocaleTimeString('ru', {
      hour: 'numeric',
      minute: 'numeric',
    });
    const mskOffset = `${offset - UtcOffsetToTimePipe.mskOffset >= 0 ? '+' : ''}${
      offset - UtcOffsetToTimePipe.mskOffset
    }`;
    const utcOffset = `${offset >= 0 ? '+' : ''}${offset}`;

    return `${time} (MSK${mskOffset}/UTC${utcOffset})`;
  }
}
